<template>
    <div class="container">
        <div>
            <h3>Reset password</h3>
        </div>

        <template v-if="reset.info" >
            <feedback :info="reset.info"></feedback>
        </template>
        <template v-else>
            <feedback :error="reset.error"/>

            <div class="form-group">
                <label>Email</label>
                <input class="form-control" type="email"
                       v-bind:class="{'is-invalid': reset.fieldErrors.email}"
                       v-bind:value="reset.email"
                       @input="onChange"
                       name="email">
                <div class="invalid-feedback" v-if="reset.fieldErrors.email">
                    {{reset.fieldErrors.email}}
                </div>
            </div>

            <div class="form-group">
                <button type="button"
                        v-on:click="submit" v-if="!reset.submitting"
                        class="btn btn-primary">Submit</button>
            </div>
        </template>

    </div>
</template>

<script>

    import Feedback from "../commons/feedback";
    import {mapState, mapActions} from "vuex";

    export default {
        name: "reset-password",
        components: {
            Feedback
        },
        computed: mapState({
            reset: state => state.resetPassword,
        }),
        methods: {
            ...mapActions({
                resetPassword: "resetPassword",
                passwordResetOnChange: "passwordResetOnChange",
                validate: "passwordResetOnValidate",
                resetFields:"resetPasswordFieldClean"
            }),
            onChange(event) {
                this.passwordResetOnChange({name: event.target.name, value: event.target.value});
            },
            submit() {
                this.validate();
                if(this.reset.error){
                    return;
                }

                this.resetPassword();
            }
        },
        mounted() {
            this.resetFields();
        }
    }
</script>

<style scoped>

</style>
